import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-24 bg-zinc-900 px-4 overflow-hidden" style={{
    perspective: "1000px"
  }} data-id="element-57" data-mp="1o2vk0ww891a9">
      <div className="max-w-3xl mx-auto relative" data-id="element-58" data-mp="222wkib8ky6p7">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-md bg-amber-500/20 blur-[100px] rounded-full pointer-events-none" data-id="element-59" data-mp="1x5mw8ywxg12y" />
        
        <motion.div initial={{
        opacity: 0,
        y: 100,
        rotateX: 40,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        y: 0,
        rotateX: 0,
        scale: 1
      }} viewport={{
        once: true,
        margin: "-100px"
      }} transition={{
        duration: 1,
        type: "spring",
        bounce: 0.4
      }} className="p-6 md:p-14 rounded-3xl bg-gradient-to-br from-zinc-800 to-zinc-950 border border-amber-500/30 text-center relative overflow-hidden shadow-[0_0_50px_rgba(245,158,11,0.15)] group" data-id="element-60" data-mp="14gfn75zujt3g">
          {/* Animated sweeping shine */}
          <motion.div animate={{
          x: ['-200%', '200%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: "linear",
          repeatDelay: 2
        }} className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 z-0 pointer-events-none" data-id="element-61" data-mp="oz02xtw5fyns" />

          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-amber-500/20 via-transparent to-transparent z-0 pointer-events-none" data-id="element-62" data-mp="12sr4aezq8c8f" />
          
          <motion.div animate={{
          y: [0, -15, 0],
          scale: [1, 1.1, 1],
          filter: ["drop-shadow(0 0 0px rgba(245,158,11,0))", "drop-shadow(0 0 30px rgba(245,158,11,0.6))", "drop-shadow(0 0 0px rgba(245,158,11,0))"]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }} className="relative z-10 inline-block mb-8" data-id="element-63" data-mp="f0u5pplafgp9">
            <ShieldCheck className="w-20 h-20 text-amber-500 mx-auto" data-id="element-64" data-mp="3rhf9aiuww40l" />
          </motion.div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 relative z-10" data-id="element-65" data-mp="3ngd7pvdivfvg">
            Garantía Blindada de <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-66" data-mp="5b09wfb4miln">7 Días</span>
          </h2>
          
          <div className="space-y-4 text-zinc-300 text-lg relative z-10 max-w-2xl mx-auto" data-id="element-67" data-mp="38rz6fovr7zh0">
            <p data-id="element-68" data-mp="33t5ui0w48giy">Prueba el protocolo completo. Crea tus anuncios. Únete al grupo.</p>
            <p data-id="element-69" data-mp="33rb5obhq449l">Si en <strong className="text-white" data-id="element-70" data-mp="33rb8ej93yida">7 días</strong> no te sirve para absolutamente nada, te devolvemos el 100% de tu dinero. Sin preguntas. Sin letra pequeña. Sin complicaciones.</p>
            
            <motion.div whileHover={{
            scale: 1.05
          }} className="inline-block px-6 py-3 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 font-medium mt-6 cursor-default" data-id="element-71" data-mp="2q1r9joine599">
              El único riesgo real es seguir pagando $3,000 al mes por lo que aquí cuesta $11.99.
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}